import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SidebarEvaluacionDesempenio from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  deleteMetricByFactor,
  editMetricByFactor,
  getMetricByFactor,
  resetMetricByFactor,
  saveMetricByFactor,
} from "../../../redux/evaluacion_desempenio/MetricByFactor/actions";
import { getFactor } from "../../../redux/evaluacion_desempenio/Factor/actions";
import {
  getPeriodicity,
  getPeriodicityByOrg,
  resetPeriodicity,
  resetPeriodicityByOrg,
} from "../../../redux/evaluacion_desempenio/Periodicity/actions";
import {
  getClassification,
  saveClassification,
  editClassification,
  deleteClassification,
} from "../../../redux/Classification/actions";
import { getOrgs } from "../../../redux/organization/actions";

const MetricByFactor = (props) => {
  const filters = [
    { id: "descripcion", desc: "Desempeño" },
    { id: "puntos", desc: "Puntos" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [factorIsSelected, setFactorIsSelected] = useState({});
  const [isOrgSelect, setIsOrgSelect] = useState(false);
  const [_empresa, setEmpresa] = useState("");
  const [_periodo, setPeriodo] = useState("");
  const [_clasificacion, setClasificacion] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "descripcion",
    desc: "Desempeño",
  });

  const dispatch = useDispatch();

  const fecha = new Date();
  var n = fecha.getFullYear();

  const schema = Yup.object().shape({
    // factor: Yup.string().required("**Campo requerido"),
    nombre: Yup.string().required("**Campo requerido"),
    descripcion: Yup.string().required("**Campo requerido"),
    puntos: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(1, "El valor minimo es 1.")
      .max(5, "El valor maximo es 5.")
      .required("**Campo requerido"),
    empresa: Yup.string().required("**Campo requerido"),
  });

  const {
    loading,
    saveLoading,
    metricByFactorsLength,
    metricByFactors,
    metricByFactorError,
    formError,
  } = useSelector((store) => store.metricByFactor);
  const pages = Math.ceil(metricByFactorsLength / limit);

  // const { factorsLength, factors, factorError } = useSelector(
  //   (store) => store.factor
  // );
  // const loadingFactor = useSelector((store) => store.factor.loading);

  const {
    loading: loadingPeriodicity,
    saveLoading: saveLoadingPeriodicity,
    periodicity,
    periodicityError,
    formError: formErrorPeriodicity,
    periodicitys,
    loadingPeriodicitys,
  } = useSelector((store) => store.periodicity);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);
  const loadingClasificacion = useSelector(
    (store) => store.classification.loading
  );
  const dataClasificacion = useSelector(
    (store) => store.classification.classification
  );
  const columns = [
    {
      Header: "Empresa",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? value.row.original.list_periodicidad[0].list_empresa[0].nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Clasificación",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? value.row.original.list_periodicidad[0].list_clasificacion[0].nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Código",
      accessor: "nombre",
      Filter: "",
    },
    {
      Header: "Desempeño",
      accessor: "descripcion",
      Filter: "",
    },
    {
      Header: "Puntos",
      accessor: "puntos",
      Filter: "",
    },
    {
      Header: "Fecha de cierre",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? moment(value.row.original.list_periodicidad[0].fecha_fin).format(
                "DD/MM/YYYY"
              )
            : ""}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const _getMetricByFactor = (
    offs = offset,
    lim = limit,
    filt = filter,
    period = _periodo,
  ) =>
    dispatch(
      getMetricByFactor({
        offset: offs,
        limit: lim,
        tipo_busqueda: "periodicidad_id",
        filter: period,
        tipo_busqueda_2: tipoBusqueda.id,
        filter_2: filt,
      })
    );

  useEffect(() => {
    // _getMetricByFactor();
    // dispatch(getFactor({}));
    setEmpresa("");
    setPeriodo("");
    setFilter("");
    dispatch(resetMetricByFactor());
    dispatch(resetPeriodicity());
    dispatch(resetPeriodicityByOrg());
    dispatch(getOrgs(parseInt(2)));
    getAClassification({});
    // dispatch(getOrgs(parseInt(2)));
  }, []);

  useEffect(() => {
    if (periodicitys && periodicitys.length > 0 && _periodo !== "") {
      // setPeriodo(periodicitys[periodicitys.length - 1].id);
      if (periodicitys.find((e) => e.anio === n)) {
        _getMetricByFactor(
          offset,
          limit,
          "",
          periodicitys.find((e) => e.anio === n).id
        );
      } else {
        _getMetricByFactor(
          offset,
          limit,
          "",
          periodicitys[periodicitys.length - 1].id
        );
      }
    }
  }, [periodicitys, _periodo]);

  useEffect(() => {
    if (periodicitys && periodicitys.length > 0) {
      if (periodicitys.find((e) => e.anio === n)) {
        setPeriodo(periodicitys.find((e) => e.anio === n).id);
      } else {
        setPeriodo(periodicitys[periodicitys.length - 1].id);
      }
    }
  }, [periodicitys]);

  const getAClassification = (filt = filter) =>
    dispatch(
      getClassification(
        {
          filter: filt,
        },
        2
      )
    );

  const onAdd = () => {
    if (_empresa !== "") {
      setIsOrgSelect(true);
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(parseInt(_empresa)),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: _clasificacion,
          tipo_busqueda_3: "anio",
          filter_3: parseInt(n),
        })
      );
    } else {
      setIsOrgSelect(false);
    }
    setFactorIsSelected({});
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    if (item.periodicidad) {
      setIsOrgSelect(true);
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(item.list_periodicidad[0].empresa),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: _clasificacion,
          tipo_busqueda_3: "anio",
          filter_3: parseInt(item.list_periodicidad[0].anio),
        })
      );
    }
    if (item.factor) {
      setFactorIsSelected(item.list_factor[0]);
    } else {
      setFactorIsSelected({});
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMetricByFactor(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _req = {
      // factor: req.factor,
      nombre: req.nombre,
      descripcion: req.descripcion,
      puntos: req.puntos,
      // empresa: req.empresa,
      // periodicidad: periodicity.id,
    };
    if (!edit) {
      _req.periodicidad = periodicity.id;
      dispatch(saveMetricByFactor(_req, setShowModal));
    } else {
      dispatch(editMetricByFactor(_req, editItem.id, index, setShowModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMetricByFactor(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteMetricByFactor(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarEvaluacionDesempenio show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Métrica por factor
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col md="12">
            <Row>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      {/* {!loadingClasificacion && (
                            <> */}
                      <Col sm={loadingClasificacion ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="clasificacion"
                          name="clasificacion"
                          className="col rounded-pill"
                          defaultValue=""
                          onChange={(e) => {
                            e.preventDefault();

                            setClasificacion(e.currentTarget.value);
                            if (_empresa !== "") {
                              dispatch(
                                getPeriodicity({
                                  tipo_busqueda: "empresa__id",
                                  filter: parseInt(_empresa),

                                  tipo_busqueda_2: "clasificacion_id",
                                  filter_2: parseInt(e.currentTarget.value),
                                })
                              );
                            }
                            // _getFactor(
                            //   offset,
                            //   limit,
                            //   filter,
                            //   e.currentTarget.value
                            // );
                            //     dispatch(
                            //       getPeriodicity({
                            //        tipo_busqueda: "empresa__id",
                            //        filter: parseInt(e.currentTarget.value),
                            //</Col>     })
                            //   );
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            //  selected
                            //  disabled
                          >
                            Selecionar clasificación
                          </option>
                          {dataClasificacion
                            ? dataClasificacion.length > 0 &&
                              dataClasificacion
                                .sort((a, b) =>
                                  a.nombre > b.nombre
                                    ? 1
                                    : b.nombre > a.nombre
                                    ? -1
                                    : 0
                                )
                                .map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.nombre ? item.nombre : ""}
                                  </option>
                                ))
                            : ""}
                        </Form.Control>
                      </Col>
                      {/* </>
                          )} */}
                      {loadingClasificacion ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Empresa
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingOrgs ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="empresa"
                          name="empresa"
                          className="col rounded-pill"
                          value={_empresa}
                          disabled={loadingOrgs}
                          onChange={(e) => {
                            e.preventDefault();
                            setEmpresa(e.currentTarget.value);
                            if (_clasificacion !== "") {
                              dispatch(
                                getPeriodicity({
                                  tipo_busqueda: "empresa__id",
                                  filter: parseInt(e.currentTarget.value),

                                  tipo_busqueda_2: "clasificacion_id",
                                  filter_2: parseInt(_clasificacion),
                                })
                              );
                            }
                            // _getMetricByFactor(
                            //   offset,
                            //   limit,
                            //   filter,
                            //   e.currentTarget.value
                            // );
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingOrgs ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Periodicidad
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      {!loadingPeriodicitys && (
                        <>
                          <Col sm={loadingPeriodicitys ? "10" : "12"}>
                            <Form.Control
                              as="select"
                              id="periodicidad"
                              name="periodicidad"
                              className="col rounded-pill"
                              defaultValue={
                                periodicitys &&
                                periodicitys.length > 0 &&
                                periodicitys.find((e) => e.anio === n)
                                  ? periodicitys.find((e) => e.anio === n).id
                                  : periodicitys && periodicitys.length > 0
                                  ? periodicitys[periodicitys.length - 1].id
                                  : ""
                              }
                              disabled={
                                loadingPeriodicitys ||
                                (periodicitys && periodicitys.length === 0)
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                setPeriodo(e.currentTarget.value);
                                _getMetricByFactor(
                                  offset,
                                  limit,
                                  filter,
                                  e.currentTarget.value,
                                  _clasificacion
                                );
                              }}
                            >
                              <option
                                className="text-muted"
                                value=""
                                selected
                                disabled
                              >
                                Selecionar periodicidad
                              </option>
                              {periodicitys.length > 0 &&
                                periodicitys.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.list_frecuencia[0].nombre}
                                    {" - "}
                                    {moment(item.fecha_fin).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </option>
                                ))}
                            </Form.Control>
                          </Col>
                        </>
                      )}
                      {loadingPeriodicitys ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            metricByFactorsLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={metricByFactors} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={metricByFactorsLength}
                  pages={pages}
                  pagFunc={_getMetricByFactor}
                />
              </>
            )
          )}
          {!loading &&
            metricByFactorsLength === 0 &&
            metricByFactorError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!metricByFactorError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {metricByFactorError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            // factor: edit ? editItem.factor : "",
            nombre: edit ? (editItem.nombre ? editItem.nombre : "") : "",
            descripcion: edit ? editItem.descripcion : "",
            puntos: edit ? editItem.puntos : "",
            empresa: edit
              ? editItem.periodicidad
                ? editItem.list_periodicidad[0].empresa
                : ""
              : _empresa,
            clasificacion: _clasificacion,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit
                    ? "Editar métrica por factor"
                    : "Crear métrica por factor"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                {!loadingPeriodicity &&
                  !edit &&
                  periodicityError === "" &&
                  !periodicity.id &&
                  isOrgSelect && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      El periodo de evaluación ya cerro o no se ha definido,
                      para mas información comunicarse con el administrador.
                    </Alert>
                  )}
                {!loadingPeriodicity &&
                  !edit &&
                  periodicityError === "" &&
                  periodicity.id &&
                  isOrgSelect && (
                    <Alert variant="info" className="mt-1 mb-2">
                      Si el periodo de evaluación ya esta siendo utilizado no
                      podra eliminar el registro.
                    </Alert>
                  )}
                {edit &&
                  moment(fecha) >
                    moment(editItem.list_periodicidad[0].fecha_fin) && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      La plantilla ya ha cerrado.
                    </Alert>
                  )}
                {(_clasificacion === "" || _empresa === "") && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    Debe seleccionar una clasificación y una empresa
                    previamente, para poder agregar un nuevo registro.
                  </Alert>
                )}
                {/* {!loadingPeriodicity &&
                  !edit &&
                  periodicityError === "" &&
                  !periodicity.id &&
                  isOrgSelect && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      El periodo de evaluación ya cerro, para mas información
                      comunicarse con el administrador.
                    </Alert>
                  )} */}
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Empresa
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingOrgs || loadingPeriodicity ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="empresa"
                          name="empresa"
                          className="col rounded-pill"
                          isInvalid={touched.empresa && errors.empresa}
                          isValid={touched.empresa && !errors.empresa}
                          onBlur={handleBlur("empresa")}
                          value={values.empresa}
                          // defaultValue={empresa}
                          disabled={loadingOrgs || loadingPeriodicity}
                          onChange={(e) => {
                            dispatch(
                              getPeriodicityByOrg({
                                tipo_busqueda: "empresa__id",
                                filter: parseInt(e.currentTarget.value),
                              })
                            );
                            if (e.currentTarget.value !== "") {
                              setIsOrgSelect(true);
                            } else {
                              setIsOrgSelect(false);
                            }
                            handleChange(e);
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingOrgs || loadingPeriodicity ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.empresa && errors.empresa && (
                      <Col>
                        <small className="text-danger">{errors.empresa}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group> */}
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Factor
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loadingFactor ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="factor"
                          name="factor"
                          className="col rounded-pill"
                          onBlur={handleBlur("factor")}
                          value={values.factor}
                          onChange={(e) => {
                            setFieldValue("factor", e.currentTarget.value);
                            const factorTemp = factors.find(
                              (ft) => ft.id === parseInt(e.currentTarget.value)
                            );
                            setFactorIsSelected(factorTemp);
                          }}
                          isValid={touched.factor && !errors.factor}
                          isInvalid={touched.factor && !!errors.factor}
                          disabled={
                            loadingFactor ||
                            (!loadingFactor && factorsLength === 0)
                          }
                        >
                          <option value="" selected disabled>
                            Seleccione un factor
                          </option>
                          {factors.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                      {loadingFactor && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.estado && errors.estado && (
                      <Col>
                        <small className="text-danger">{errors.estado}</small>
                      </Col>
                    )}
                    {!!factorError && (
                      <Col>
                        <small className="text-danger">**{factorError}</small>
                      </Col>
                    )}
                    {!loadingFactor && factorsLength === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron factores
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Peso
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <Form.Control
                          disabled
                          value={factorIsSelected.peso}
                          className="rounded-pill"
                          type="text"
                        ></Form.Control>
                      </Col>
                    </Row>
                  </Col>
                </Form.Group> */}
                {/* <Form.Group as={Row} className="mb-md-0">
                  <Form.Label column sm={3}>
                    Desempeno esperado
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <Form.Control
                          disabled
                          value={factorIsSelected.desempeno_esperado}
                          className="rounded-pill"
                          type="text"
                        ></Form.Control>
                      </Col>
                    </Row>
                  </Col>
                </Form.Group> */}

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Empresa
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingOrgs || loadingPeriodicity ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="empresa"
                          name="empresa"
                          className="col rounded-pill"
                          isInvalid={touched.empresa && errors.empresa}
                          isValid={touched.empresa && !errors.empresa}
                          onBlur={handleBlur("empresa")}
                          value={values.empresa}
                          // defaultValue={empresa}
                          // disabled={
                          //   edit ||
                          //   loadingOrgs ||
                          //   loadingPeriodicity ||
                          //   (edit && moment(fecha) > moment(editItem.fecha_fin))
                          // }
                          disabled
                          onChange={(e) => {
                            dispatch(
                              getPeriodicityByOrg({
                                tipo_busqueda: "empresa__id",
                                filter: parseInt(e.currentTarget.value),
                              })
                            );
                            if (e.currentTarget.value !== "") {
                              setIsOrgSelect(true);
                            } else {
                              setIsOrgSelect(false);
                            }
                            handleChange(e);
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingOrgs || loadingPeriodicity ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.empresa && errors.empresa && (
                      <Col>
                        <small className="text-danger">{errors.empresa}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Clasificacion
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <Form.Control
                          as="select"
                          id="clasificacion"
                          name="clasificacion"
                          className="col rounded-pill"
                          isInvalid={
                            touched.clasificacion && errors.clasificacion
                          }
                          isValid={
                            touched.clasificacion && !errors.clasificacion
                          }
                          onBlur={handleBlur("clasificacion")}
                          value={values.clasificacion}
                          disabled
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar clasificacion
                          </option>
                          {dataClasificacion
                            ? dataClasificacion.length > 0 &&
                              dataClasificacion.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.nombre ? item.nombre : ""}
                                </option>
                              ))
                            : ""}
                        </Form.Control>
                        {touched.clasificacion && errors.clasificacion && (
                          <Col>
                            <small className="text-danger">
                              {errors.clasificacion}
                            </small>
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Código
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <Form.Control
                          id="nombre"
                          name="nombre"
                          isInvalid={touched.nombre && errors.nombre}
                          isValid={touched.nombre && !errors.nombre}
                          onBlur={handleBlur("nombre")}
                          onChange={handleChange}
                          value={values.nombre}
                          className="rounded-pill"
                          type="text"
                          placeholder="Código"
                          disabled={
                            edit && n !== editItem.list_periodicidad[0].anio
                            // edit &&
                            // moment(fecha) >
                            //   moment(editItem.list_periodicidad[0].fecha_fin)
                          }
                        ></Form.Control>
                        {touched.nombre && errors.nombre && (
                          <div>
                            <small className="text-danger">
                              {errors.nombre}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Desempeño
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <Form.Control
                          id="descripcion"
                          name="descripcion"
                          isInvalid={touched.descripcion && errors.descripcion}
                          isValid={touched.descripcion && !errors.descripcion}
                          onBlur={handleBlur("descripcion")}
                          onChange={handleChange}
                          value={values.descripcion}
                          className="rounded-pill"
                          type="text"
                          placeholder="Tipo de evaluación"
                          disabled={
                            edit && n !== editItem.list_periodicidad[0].anio
                            // edit &&
                            // moment(fecha) >
                            //   moment(editItem.list_periodicidad[0].fecha_fin)
                          }
                        ></Form.Control>
                        {touched.descripcion && errors.descripcion && (
                          <div>
                            <small className="text-danger">
                              {errors.descripcion}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Puntos
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="puntos"
                          name="puntos"
                          isInvalid={touched.puntos && errors.puntos}
                          isValid={touched.puntos && !errors.puntos}
                          onBlur={handleBlur("puntos")}
                          onChange={handleChange}
                          value={values.puntos}
                          className="rounded-pill"
                          type="number"
                          placeholder="0"
                          min={1}
                          max={5}
                          // step={1}
                          disabled={
                            edit && n !== editItem.list_periodicidad[0].anio
                            // edit &&
                            // moment(fecha) >
                            //   moment(editItem.list_periodicidad[0].fecha_fin)
                          }
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.puntos && errors.puntos && (
                      <Col>
                        <small className="text-danger">{errors.puntos}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                {edit && n !== editItem.list_periodicidad[0].anio ? null : ( //   moment(editItem.list_periodicidad[0].fecha_fin) // moment(fecha) > // edit &&
                  <>
                    <Button
                      className="rounded-pill"
                      disabled={
                        saveLoading ||
                        (!loadingPeriodicity &&
                          !edit &&
                          periodicityError === "" &&
                          !periodicity.id &&
                          isOrgSelect) ||
                        (edit &&
                          moment(fecha) >
                            moment(editItem.list_periodicidad[0].fecha_fin)) ||
                        loadingOrgs ||
                        loadingPeriodicity ||
                        values.empresa === ""
                      }
                      variant="primary"
                      type="submit"
                    >
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  </>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default MetricByFactor;
